import type { Room } from 'livekit-client';

/**
 * 039 phase 2 (1b) — client → voice-agent turn injection.
 *
 * When the user clicks an in-card action (e.g. the scope **Lock** button) during
 * a LIVE voice session, we must NOT route it through the text-SSE `sendMessage`
 * path: the voice agent never speaks a text turn and the voice bar wouldn't
 * cycle. Instead we publish an `inject_user_turn` data frame; the agent runs the
 * same machinery as a spoken utterance (n8n round-trip → speak the reply). The
 * event name + shape mirror `agent/src/inject-turn.ts` exactly.
 */
export const INJECT_USER_TURN_EVENT = 'inject_user_turn';

/**
 * Publish an `inject_user_turn` frame to the agent. Returns `true` when it was
 * published, `false` when there's no live local participant, the text is empty,
 * or the publish throws — the caller then falls back to the text path.
 */
export function publishInjectUserTurn(room: Room | null | undefined, text: string): boolean {
  const trimmed = text.trim();
  if (!room?.localParticipant || trimmed.length === 0) return false;
  try {
    const payload = new TextEncoder().encode(
      JSON.stringify({ event: INJECT_USER_TURN_EVENT, text: trimmed }),
    );
    void room.localParticipant.publishData(payload, { reliable: true });
    return true;
  } catch {
    return false;
  }
}
